<template>
  <section class="el-column">
    <div class="el-column__navbar">
      <emd-mundi-logo-colored v-if="componentIsEnabled('logo', 'mundipagg')" />
      <emd-pagarme-logo-green v-if="componentIsEnabled('logo', 'pagarme')" />
    </div>
    <div class="el-bounds _narrow">
      <div class="emd-text _align_center">
        <div class="el-section">
          <svg
            class="emeraldraws"
            width="148px"
            height="148px"
            viewBox="0 0 148 148"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="delinquent"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <path
                d="M100.979167,52.3125 L86.7020833,38.0208333 C86.0458333,37.3645833 85.15625,37 84.2229167,37 L83.3333333,37 L83.3333333,55.6666667 L102,55.6666667 L102,54.7770833 C102,53.8583333 101.635417,52.96875 100.979167,52.3125 Z M78.6666667,56.8333333 L78.6666667,37 L49.5,37 C47.5604167,37 46,38.5604167 46,40.5 L46,108.166667 C46,110.10625 47.5604167,111.666667 49.5,111.666667 L98.5,111.666667 C100.439583,111.666667 102,110.10625 102,108.166667 L102,60.3333333 L82.1666667,60.3333333 C80.2416667,60.3333333 78.6666667,58.7583333 78.6666667,56.8333333 Z M55.3333333,47.5 C55.3333333,46.8554167 55.8554167,46.3333333 56.5,46.3333333 L68.1666667,46.3333333 C68.81125,46.3333333 69.3333333,46.8554167 69.3333333,47.5 L69.3333333,49.8333333 C69.3333333,50.4779167 68.81125,51 68.1666667,51 L56.5,51 C55.8554167,51 55.3333333,50.4779167 55.3333333,49.8333333 L55.3333333,47.5 Z M55.3333333,59.1666667 L55.3333333,56.8333333 C55.3333333,56.18875 55.8554167,55.6666667 56.5,55.6666667 L68.1666667,55.6666667 C68.81125,55.6666667 69.3333333,56.18875 69.3333333,56.8333333 L69.3333333,59.1666667 C69.3333333,59.81125 68.81125,60.3333333 68.1666667,60.3333333 L56.5,60.3333333 C55.8554167,60.3333333 55.3333333,59.81125 55.3333333,59.1666667 Z M74,0 C114.869071,0 148,33.1309285 148,74 C148,114.869071 114.869071,148 74,148 C33.1309285,148 0,114.869071 0,74 C0,33.1309285 33.1309285,0 74,0 Z M74,6 C36.444637,6 6,36.444637 6,74 C6,111.555363 36.444637,142 74,142 C111.555363,142 142,111.555363 142,74 C142,36.444637 111.555363,6 74,6 Z M75.1652083,69.6666667 C75.8097917,69.6666667 76.331875,70.18875 76.331875,70.8333333 L76.331875,74.375625 C77.9783333,74.4602083 79.5795833,75.0333333 80.9066667,76.0308333 C81.4754167,76.458125 81.5045833,77.3097917 80.9897917,77.80125 L79.27625,79.4360417 C78.8722917,79.8210417 78.2714583,79.8385417 77.7989583,79.5425 C77.2345833,79.188125 76.594375,79 75.929375,79 L71.83,79 C70.8820833,79 70.1091667,79.8633333 70.1091667,80.9235417 C70.1091667,81.79125 70.635625,82.5554167 71.388125,82.78 L77.950625,84.74875 C80.6616667,85.5625 82.5560417,88.1641667 82.5560417,91.0764583 C82.5560417,94.65375 79.7779167,97.5572917 76.3333333,97.6491667 L76.3333333,101.166667 C76.3333333,101.81125 75.81125,102.333333 75.1666667,102.333333 L72.8333333,102.333333 C72.18875,102.333333 71.6666667,101.81125 71.6666667,101.166667 L71.6666667,97.624375 C70.0202083,97.5397917 68.4189583,96.9652083 67.091875,95.9691667 C66.523125,95.541875 66.4939583,94.6902083 67.00875,94.19875 L68.7222917,92.5639583 C69.12625,92.1789583 69.7270833,92.1614583 70.1995833,92.4575 C70.7639583,92.8104167 71.4041667,93 72.0691667,93 L76.1685417,93 C77.1164583,93 77.889375,92.1366667 77.889375,91.0764583 C77.889375,90.20875 77.3629167,89.4445833 76.6104167,89.22 L70.0479167,87.25125 C67.336875,86.4375 65.4425,83.8358333 65.4425,80.9235417 C65.4425,77.3477083 68.220625,74.4427083 71.6652083,74.3508333 L71.6652083,70.8333333 C71.6652083,70.18875 72.1872917,69.6666667 72.831875,69.6666667 L75.1652083,69.6666667 Z"
                id="black-500"
                fill-rule="nonzero"
              ></path>
            </g>
          </svg>
        </div>
        <div class="el-section">
          <div class="eu-flex eu-justify_center">
            <div class="eu-flex-item eu-basis_12 eu-basis_8_sm eu-basis_6_md">
              <div class="el-chunk">
                <h2 class="emd-text _size_subpage">
                  <b>
                    {{ $t(`delinquent.${localeType}.title`) }}
                  </b>
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_subtle">
                  {{ $t(`delinquent.${localeType}.subtitle`) }}
                </p>
              </div>
              <div class="el-section eu-align_left">
                <div class="emd-container _type_card">
                  <div class="emd-container__content">
                    <p class="eu-text-overflow emd-text _size_section">
                      <b>
                        {{ profile.merchant.name }}
                      </b>
                    </p>
                    <p
                      class="emd-text _color_subtle _color_subtle eu-text-overflow"
                    >
                      {{ profile.merchant.id }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="el-section">
                <button
                  class="emd-btn _color_primary"
                  @click="callToAction"
                >
                  {{ $t(`delinquent.${localeType}.cta`) }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="eu-pt_6">
      <Footer />
    </div>
  </section>
</template>

<script>
import {
  EmdMundiLogoColored,
  EmdPagarmeLogoGreen
} from 'emerald-vue/src/components'
import Footer from '@/components/project/globals/Footer.vue'
import { MERCHANT_TYPES, isOwnerOrAdmin } from '@/enums/merchant-type.enum'
import { mapGetters } from 'vuex'
export default {
  name: 'Delinquent',
  components: {
    EmdMundiLogoColored,
    EmdPagarmeLogoGreen,
    Footer
  },
  computed: {
    ...mapGetters({
      profile: 'profile'
    }),
    isAdmin () {
      return isOwnerOrAdmin(this.profile.merchant.type.key)
    },
    localeType () {
      if (this.isAdmin) {
        return MERCHANT_TYPES.ADMIN
      }

      return MERCHANT_TYPES.STAFF
    }
  },
  methods: {
    callToAction () {
      if (this.isAdmin) {
        window.location.assign(
          `${process.env.VUE_APP_COMPANY_URL}/${this.profile.merchant.id}/myplan/invoices`
        )
      } else {
        window.location.assign(`${process.env.VUE_APP_PROFILE_URL}`)
      }
    },
    componentIsEnabled (section, component) {
      return this.$store.getters.componentIsEnabled(section, component)
    }
  }
}
</script>
